import { useEffect, useState } from 'react'
import LandCom from '../Buy/LandCom'
import getServices from '../../Services/get-service';
import { TablePagination } from '@mui/material';
import { toast } from 'react-toastify';
function Investment() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  // const [open, setOpen] = useState(false)
  // const handleClose = () => setOpen(false)
  // const [open1, setOpen1] = useState(false)
  // const handleClose1 = () => setOpen1(false)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    setLoading(true);
    getServices.getSavedProduct().then(
      (response) => {
        setLoading(false);
        if (response.data.statusCode === 200) {
          const rawData = response.data.data;
          let allSaved = [];
          if (Array.isArray(rawData)) allSaved = rawData;
          else if (rawData && Array.isArray(rawData.savedProperties)) allSaved = rawData.savedProperties;
          else if (rawData && Array.isArray(rawData.content)) allSaved = rawData.content;
          else if (rawData && Array.isArray(rawData.data)) allSaved = rawData.data;

          setProjects(allSaved.reverse());
        } else {
          toast.error(response.data.description);
        }
      },
      (error) => {
        setLoading(false);
        toast.error(error?.response?.data?.description);
      }
    );
  }, []);
  return (
    <div className=' mt-4'>
      {loading ? (
        <div className=' grid sm:grid-cols-2 lg:grid-cols-3 gap-4'>
          {[1, 2, 3, 4, 5, 6].map(item => (
            <LandCom key={item} loading={true} />
          ))}
        </div>
      ) : (
        <div className=' grid sm:grid-cols-2 lg:grid-cols-3 gap-4'>
          {projects.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(project => {
              return <div key={project.id}>
                <LandCom
                  bool={true}
                  saveStatus={true}
                  id={project.propertyId || project.id}
                  img={project.propertyImages?.[0]?.imageUrl || project.imageUrl}
                  //onClick={handleChange}
                  link={`/buy/productdetails/${project.projectId || project.id}`}
                  percentage={project.percentSold || project.percentageSold || 0}
                  per={Math.floor(project.percentSold || project.percentageSold || 0)}
                  name={project.projectName || project.title}
                  state={project.projecLocation || project.locality || 'Lagos'}
                  totalAmount={project.projectPriceTotal || project.price || 0}
                  raisedAmount={(project.pricePerPlot * project.unitSold) || project.amountRaised || 0}
                  onRemove={(removedId) => {
                    setProjects(prev => prev.filter(p => (p.propertyId || p.id) !== removedId));
                  }}
                />

              </div>

            })}

        </div>
      )}
      {!loading && projects.length === 0 && (
        <div className="flex flex-col items-center justify-center mt-20">
          <div className="bg-white p-4 rounded-full shadow-sm mb-4">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#00BC67"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">No Saved Investments</h3>

        </div>
      )}
      <div className=' flex justify-center'>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={projects.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  )
}

export default Investment